/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

//--- Action
import * as newsAction from "../../../redux/store/news/news.store";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import * as viVN from "../../../language/vi-VN.json";

//--- Material Control
import {
    DialogActions,
    TextareaAutosize,
    Button,
    TextField,
    DialogContent,
    DialogTitle,
    Dialog,
    makeStyles,
    Typography,
    IconButton,
    Select,
    MenuItem,
    Checkbox,
} from "@material-ui/core";

//--- Material Icon
import CloseIcon from "@material-ui/icons/Close";
import SaveIcon from "@material-ui/icons/Save";

//--- Notifications
import FileInputComponent from "../../../components/file-input/file-input.view";
import ShowNotification from "../../../components/react-notifications/react-notifications";
import {
    NotificationMessageType,
    APIUrlDefault,
    MaxSizeImageUpload,
} from "../../../utils/configuration";
import * as appActions from "../../../core/app.store";
import FileManagement from "../../../components/file_management/file_management";
//--- Styles
import "../news.scss";

const useStyles = makeStyles((theme) => ({
    closeButton: {
        position: "absolute",
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
}));

function EditNews(props) {
    const classes = useStyles();

    const {
        isOpen,
        onClose,
        onSuccess,
        newsId,

        categoryId,
        newsDetail,
        GetListAll,
        Update,
    } = props;

    const [newsModel, setNewsModel] = useState();
    const [status, setStatus] = useState(true);
    const [isHot, setIsHot] = useState(true);
    const [imageUrl, setImageUrl] = useState("");
    const [content, setContent] = useState();
    const [isDeleteImage, setIsDeleteImage] = useState(false);
    const [isShow, setShow] = useState(false);
    const [files, setFiles] = useState([]);
    const [filesTemp, setFilesTemp] = useState([]);

    useEffect(() => {
        setNewsModel(newsDetail);
        setImageUrl(newsDetail?.image_Url);
        setStatus(newsDetail?.status==1? true:false);
        setIsHot(newsDetail?.isHot==1? true : false);
        setContent(newsDetail?.content);
        setFiles(newsDetail?.files ? [newsDetail.files] : []);
    }, [newsDetail]);

    const { register, handleSubmit, setError, errors, clearErrors, setValue } = useForm({
        mode: "all",
        reValidateMode: "onBlur",
    });

    const onSubmit = (data) => {
        if (!data) {
            return;
        }

        let formData = new FormData();
        formData.append("id", newsId);
        formData.append("xmin", newsModel.xmin);
        data.title && formData.append("title", data.title);
        data.description && formData.append("description", data.description);
        formData.append("content", content);
        formData.append("image_Url", imageUrl);
        formData.append("status", status ? 1 : 0);
        formData.append("isHot", isHot ? 1 : 0);
        formData.append("isDeleteImage", isDeleteImage ? 1 : 0);
        formData.append("isFeature", 0);
        formData.append("isHomePage", 0);
        formData.append("categoryId", categoryId);
        if (files && files.length > 0)
            formData.append("documentUploadId", files[0].fileId);
        if (Update(formData))
            onSuccess();
    };

    const handleChangeContent = (editorContent) => {
        clearErrors(["editorContent"]);
        if (editorContent == "<p><br></p>") {
            setError("editorContent", { type: "required" });
            setContent("");
        } else {
            clearErrors("editorContent");
            setContent(editorContent);
        }
    };

    const handleChangeStatus = (event) => {
        event.persist();
        setStatus(event.target.checked);
    }

    const handleChangeHot = (event) => {
        event.persist();
        setIsHot(event.target.checked);
    }

    const onOpenSelectFile = () => {
        setShow(true);
        setFilesTemp(files);
    };

    const onCloseSelectFile = () => {
        setShow(false);
        setFiles(filesTemp);
    };

    const onSaveSelectFile = () => {
        setShow(false);
    };

    return (
        <div>
            <Dialog open={isOpen} onClose={onClose} fullWidth={true} maxWidth="lg">
                <DialogTitle disableTypography className="border-bottom">
                    <Typography variant="h6">Chỉnh sửa Tin tức</Typography>
                    <IconButton
                        aria-label="close"
                        className={classes.closeButton}
                        onClick={onClose}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
                    {
                        newsModel && (
                        <DialogContent className="pt-4 pb-2">
                            <div className="form-group">
                                <label className="text-dark">
                                    Tiêu đề<span className="required"></span>
                                </label>
                                <TextField
                                    inputRef={register({ required: true, maxLength: 150 })}
                                    name="title"
                                    error={errors.title && errors.title.type == "required"}
                                    fullWidth
                                    type="text"
                                    className="form-control"
                                    inputProps={{ maxLength: 150 }}
                                        defaultValue={newsModel.title}
                                    onChange={(e) =>
                                        setValue("title", e.target.value)
                                    }
                                />
                                {errors.title && errors.title.type == "required" && (
                                    <span className="error">Trường này là bắt buộc</span>
                                )}
                                {errors.title && errors.title.type == "maxLength" && (
                                    <span className="error">Trường này không quá 150 ký tự</span>
                                )}
                            </div>
                            <div className="form-group">
                                <label className="text-dark">Tóm tắt<span className="required"></span></label>
                                <textarea
                                    name="description"
                                    rows="5"
                                    ref={register({ required: true, maxLength: 500 })}
                                    className={
                                        "form-control" +
                                        (errors.description && errors.description.type == "required"
                                            ? " is-invalid"
                                            : "")
                                    }
                                    maxLength="500"
                                        defaultValue={newsModel.description}
                                ></textarea>
                                {errors.description && errors.description.type == "required" && (
                                    <span className="error">Trường này là bắt buộc</span>
                                )}
                                {errors.description && errors.description.type == "maxLength" && (
                                    <span className="error">Trường này không quá 500 ký tự</span>
                                )}

                            </div>

                            <div className="form-group">
                                <label className="text-dark">Nội dung</label>
                                <SunEditor
                                    enableToolbar={true}
                                        showToolbar={true}
                                        imageUploadSizeLimit={MaxSizeImageUpload}
                                        videoFileInput={false}
                                        setContents={newsModel.content}
                                    setOptions={{
                                        height: 500,
                                        buttonList: [
                                            [
                                                "undo",
                                                "redo",
                                                "font",
                                                "fontSize",
                                                "formatBlock",
                                                "paragraphStyle",
                                                "blockquote",
                                                "bold",
                                                "underline",
                                                "italic",
                                                "strike",
                                                "subscript",
                                                "superscript",
                                                "fontColor",
                                                "hiliteColor",
                                                "textStyle",
                                                "removeFormat",
                                                "outdent",
                                                "indent",
                                                "align",
                                                "horizontalRule",
                                                "list",
                                                "lineHeight",
                                                "table",
                                                "link",
                                                "image",
                                                "video",
                                                "audio",
                                                "fullScreen",
                                                "showBlocks",
                                                "codeView",
                                            ],
                                        ],
                                    }}
                                    onChange={handleChangeContent}
                                    onBlur={(event, editorContents) => handleChangeContent(editorContents)}
                                />
                            </div>
                            <div className="form-group">
                                <div className="row">
                                    <div className="col-12 col-md-4 col-lg-4">
                                        <label className="text-dark">Kích hoạt</label>
                                        <Checkbox
                                            checked={status}
                                            onChange={handleChangeStatus}
                                            color="primary"
                                            inputProps={{ "aria-label": "secondary checkbox" }}
                                            className="p-0 mt-0 ml-4"
                                        />
                                    </div>
                                    <div className="col-12 col-md-4 col-lg-4">
                                        <label className="text-dark">Tin nóng</label>
                                        <Checkbox
                                            checked={isHot}
                                            onChange={handleChangeHot}
                                            color="primary"
                                            inputProps={{ "aria-label": "secondary checkbox" }}
                                            className="p-0 mt-0 ml-4"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-12">
                                    <label className="text-dark">
                                        Ảnh<span className="required"></span>
                                    </label>
                                    {!isShow &&
                                        files &&
                                        files.length > 0 &&
                                        files.map((item) => (
                                            <div key={item.fileName} style={{ width: "150px" }}>
                                                <img
                                                    src={APIUrlDefault + item.filePreview}
                                                    alt={item.fileName}
                                                    className="img-fluid mb-2"
                                                    style={{
                                                        width: "auto",
                                                        height: "auto",
                                                        maxWidth: "100%",
                                                        maxHeight: "100%",
                                                    }}
                                                />
                                            </div>
                                        ))}
                                    <div>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={onOpenSelectFile}
                                        >
                                            Chọn file
                                </Button>
                                        <TextField
                                            inputRef={register({ required: true })}
                                            type="hidden"
                                            name="image"
                                            value={
                                                (files && files.length > 0 && files[0].fileName) || ""
                                            }
                                        />
                                        {errors.image && errors.image.type == "required" && (
                                            <p className="error">Trường này là bắt buộc</p>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </DialogContent>
                    )}

                    <DialogActions className="border-top">
                        <Button
                            type="button"
                            onClick={onClose}
                            variant="contained"
                            startIcon={<CloseIcon />}
                        >
                            Hủy
            </Button>
                        <Button
                            type="submit"
                            color="primary"
                            variant="contained"
                            startIcon={<SaveIcon />}
                        >
                            Lưu
            </Button>
                    </DialogActions>
                </form>
            </Dialog>

            {
                isShow && (
                    <Dialog
                        onClose={onCloseSelectFile}
                        open={isShow}
                        fullWidth={true}
                        maxWidth="md"
                        className="dialog-preview-form"
                    >
                        <DialogTitle disableTypography>
                            <Typography variant="h6">Quản lý file</Typography>
                            <IconButton
                                aria-label="close"
                                className={classes.closeButton}
                                onClick={onCloseSelectFile}
                            >
                                <CloseIcon />
                            </IconButton>
                        </DialogTitle>
                        <DialogContent dividers>
                            <FileManagement
                                files={files}
                                setFiles={setFiles}
                                acceptedFiles={["jpeg", "png", "jpg", "gif"]}
                            />
                        </DialogContent>

                        <DialogActions>
                            <Button
                                type="button"
                                onClick={onCloseSelectFile}
                                variant="contained"
                                startIcon={<CloseIcon />}
                            >
                                Hủy
                                    </Button>
                            {files && files.length > 0 && (
                                <Button
                                    type="button"
                                    color="primary"
                                    variant="contained"
                                    startIcon={<SaveIcon />}
                                    onClick={onSaveSelectFile}
                                >
                                    Lưu
                                </Button>
                            )}
                        </DialogActions>
                    </Dialog>
                )
            }
        </div>
    );
}

const mapStateToProps = state => ({
    newsDetail: state.initNews.newsDetail,
    categoryId: state.initNews.categoryId,
})

const mapDispatchToProps = dispatch => bindActionCreators({
    GetListAll: newsAction.GetList,
    Update: newsAction.Update,
    showLoading: appActions.ShowLoading,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(EditNews)
